module.exports = __webpack_public_path__ + "static/img/image064.80430d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image064.png
// module id = LM04
// module chunks = 1